module.exports = __webpack_public_path__ + "static/media/leiste_excelente_2.8e88608e.png";